import { UserDtoV3, UserOrganizationDto } from '@workers-benefit-fund/api'

import { ApiResponseSerializer } from 'src/v2/commons/interface/ApiResponseSerializer'

import { IUserMembership } from '../membership/membership.types'

export enum UserType {
  REGULAR = 'regular',
  EXTERNAL = 'external',
  TEST = 'test',
  INTEGRATION = 'integration',
  DOCTOR = 'doctor',
}

export const USER_TYPE_OPTIONS = [
  { value: UserType.REGULAR, label: 'Regular' },
  { value: UserType.EXTERNAL, label: 'External' },
  { value: UserType.TEST, label: 'Test' },
  { value: UserType.INTEGRATION, label: 'Integration' },
]

export interface IUser {
  id?: string
  firstName: string
  lastName: string
  username?: string
  hipaaCertified?: boolean
  aircallUserId?: string
  email?: string
  phone?: string
  password?: string
  membership?: IUserMembership
  emailDomains?: IMembershipEmailDomainUser[]
  type?: UserType
  inNetwork?: boolean
}

export type UsersResponseModel = ApiResponseSerializer<UserOrganizationDto>

export interface IMembershipEmailDomainUser {
  id: string
  type: 'BOTH' | 'SEND' | 'REPLY'
  name: string
  domain: string
  isWBFRegister: boolean
}

export interface SessionUser {
  id: string
  firstName: string
  lastName: string
  username?: string
  email?: string
  phone?: string
  aircallUserId?: string
}

export interface SessionMembership {
  id: string
  status?: string
  membershipRole?: { id: string; name?: string }
}

export interface SessionOrganization {
  id: string
  name: string
  code?: string
  memberships?: { id: string }[]
}

export interface CurrentSessionOrganization
  extends Omit<SessionOrganization, 'memberships'> {
  logoURL?: string
  circularLogoURL?: string
  profile?: {
    isTLCRequired?: boolean
    leadCreationRequiredFields?: string[]
    frequentlyUsedLanguages?: string[]
  }
}

export interface IUserSessionStore {
  user: SessionUser
  membership: SessionMembership
  currentOrganization: CurrentSessionOrganization
  organizations: SessionOrganization[]
  policies: string[]
}

export const LOCAL_STORAGE_USER_PROFILE = 'USER_PROFILE_SESSION'

export interface IUsersFilter {
  status?: string
  limit?: number
  offset?: number
  search?: string
  orderBy?: string
  userType?: UserType
  organizationRole?: string
}

export interface ICreateUserRequest
  extends Pick<
    UserDtoV3,
    | 'id'
    | 'firstName'
    | 'lastName'
    | 'phone'
    | 'username'
    | 'aircallUserId'
    | 'type'
  > {
  organizationId: string
  hipaaCertified?: string
  password: string
}
